export default {
    "_id": {
        "show_name": "_id",
        "name": "id",
        "type": "Field_mongoid",
        "default": ""
    },
    "updated_at": {
        "show_name": "更新时间",
        "name": "updated_at",
        "type": "Field_ts",
        "default": 0,
        "show_type": "ts"
    },
    "created_user": {
        "show_name": "创建人",
        "name": "created_user",
        "type": "Field_adminuser",
        "default": {
            "_id": null,
            "name": ""
        },
        "name_fields": [
            "name"
        ],
        "table_name": "admin_user",
        "model_name": "Adminuser"
    },
    "created_at": {
        "show_name": "创建时间",
        "name": "created_at",
        "type": "Field_ts",
        "default": 0,
        "show_type": "ts"
    },
    "deleted_at": {
        "show_name": "时间",
        "name": "deleted_at",
        "type": "Field_ts",
        "default": 0,
        "show_type": "ts"
    },
    "name": {
        "show_name": "姓名",
        "name": "name",
        "type": "Field_string",
        "default": ""
    },
    "phone": {
        "show_name": "电话",
        "name": "phone",
        "type": "Field_string",
        "default": ""
    },
    "has_leave": {
        "show_name": "已离职",
        "name": "has_leave",
        "type": "Field_bool",
        "default": false,
        "enum": {
            "0": "否",
            "1": "是"
        }
    },
    "is_superadmin": {
        "show_name": "超级管理员",
        "name": "is_superadmin",
        "type": "Field_bool",
        "default": false,
        "enum": {
            "0": "否",
            "1": "是"
        }
    },
    "is_saler": {
        "show_name": "是销售",
        "name": "is_saler",
        "type": "Field_bool",
        "default": false,
        "enum": {
            "0": "否",
            "1": "是"
        }
    },
    "password": {
        "show_name": "密码",
        "name": "password",
        "type": "Field_pwd",
        "default": ""
    },
    "privilege": {
        "show_name": "权限",
        "name": "privilege",
        "type": "Field_tag",
        "default": [],
        "enum": {
            "10": "基础建档(分类等)",
            "11": "商品建档(品牌\/商品\/尺码\/颜色)",
            "12": "设定商品价格",
            "13": "查看高级价格",
            "20": "人员管理",
            "21": "基础信息配置(仓库\/配送\/全局信息)",
            "22": "前端广告配置",
            "30": "客户管理",
            "31": "代理商充值",
            "40": "订单查看",
            "41": "开销售单",
            "42": "允许超卖",
            "43": "删除订单",
            "50": "库存查看",
            "51": "库存操作(入库等)",
            "52": "库存审核",
            "53": "查看库存数值",
            "59": "查看进货价",
            "60": "财务数据查看",
            "61": "财务审核",
            "62": "编辑财务信息",
            "70": "统计分析"
        }
    }
};
